import axios, { AxiosResponse } from 'axios';

export interface ILocaleApi {
  setLocale(locale: string): Promise<AxiosResponse<any>>;
}

export class LocaleApi implements ILocaleApi {
  async setLocale(locale: string): Promise<AxiosResponse<any>> {
    return axios.get(`i18n/${locale}.json?buildTimestamp=${process.env.BUILD_TIMESTAMP}`, { baseURL: '' });
  }
}
